import api from './api';

export const statusService = {
  async createStatusUpdate(statusData) {
    const response = await api.post('/status-updates', statusData);
    return response.data;
  },

  async getStatusUpdates(filters = {}) {
    const response = await api.get('/status-updates', { params: filters });
    return response.data;
  },

  async updateStatusUpdate(statusUpdateId, updateData) {
    const response = await api.patch(`/status-updates/${statusUpdateId}`, updateData);
    return response.data;
  },

  async getDailySummary(date, userId) {
    const response = await api.get('/status-updates/daily-summary', {
      params: { date, userId }
    });
    return response.data;
  },

  async uploadAttachment(statusUpdateId, file) {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post(
      `/status-updates/${statusUpdateId}/attachments`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  }
};
